import Component from '@glimmer/component';

export default class DateRangeErrorComponent extends Component {
  <template>
    <div class="c-error qa-error-dates" ...attributes>
      {{~yield~}}
    </div>
  </template>
}
